const TestTypes = {
  MODERATED: 'moderated',
  UNMODERATED: 'unmoderated',
  CARD_SORT: 'card_sort',
  TREE_TEST: 'tree_test',
  SURVEY: 'survey',
  UPLOAD: 'upload',
};

export default TestTypes;
